// extracted by mini-css-extract-plugin
export var callCard = "_of-0";
export var callMessageButton = "_of-1";
export var helpIcon = "_of-3";
export var helpIconContainer = "_of-4";
export var verticalDivider = "_of-2";